import React, { useState, useRef, useEffect } from 'react';

function TrapurheRadio() {
  // ============ STATE ============
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentPlaylist, setCurrentPlaylist] = useState(() => {
    const saved = localStorage.getItem('trapurhe_playlist');
    return saved ? parseInt(saved) : 0;
  });
  const [currentTrack, setCurrentTrack] = useState(0);
  const [volume, setVolume] = useState(() => {
    const saved = localStorage.getItem('trapurhe_volume');
    return saved ? parseFloat(saved) : 0.7;
  });
  const [isMuted, setIsMuted] = useState(false);
  const [listenerCount, setListenerCount] = useState(47);
  const [cdRotation, setCdRotation] = useState(0);
  const [showBackground, setShowBackground] = useState(false);
  const [isHoveringIcon, setIsHoveringIcon] = useState(false);
  const [typewriterText, setTypewriterText] = useState("");
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [recentPlays, setRecentPlays] = useState([]);
  const [sessionStartTime] = useState(Date.now());
  const [sleepTimerEnd, setSleepTimerEnd] = useState(null);
  const [showSleepMenu, setShowSleepMenu] = useState(false);
  
  const audioRef = useRef(null);
  const animationRef = useRef(null);
  const typewriterIntervalRef = useRef(null);
  const sleepTimerRef = useRef(null);

  // ============ ASCII ART ============
  const asciiArt = `$$$$$$$$\\                                               $$\\                                         $$\\     
\\__$$  __|                                              $$ |                                        $$ |    
   $$ | $$$$$$\\  $$$$$$\\   $$$$$$\\  $$\\   $$\\  $$$$$$\\  $$$$$$$\\   $$$$$$\\      $$$$$$\\   $$$$$$\\ $$$$$$\\   
   $$ |$$  __$$\\ \\____$$\\ $$  __$$\\ $$ |  $$ |$$  __$$\\ $$  __$$\\ $$  __$$\\     \\____$$\\ $$  __$$\\\\_$$  _|  
   $$ |$$ |  \\__|$$$$$$$ |$$ /  $$ |$$ |  $$ |$$ |  \\__|$$ |  $$ |$$$$$$$$ |    $$$$$$$ |$$ |  \\__| $$ |    
   $$ |$$ |     $$  __$$ |$$ |  $$ |$$ |  $$ |$$ |      $$ |  $$ |$$   ____|   $$  __$$ |$$ |       $$ |$$\\ 
   $$ |$$ |     \\$$$$$$$ |$$$$$$$  |\\$$$$$$  |$$ |      $$ |  $$ |\\$$$$$$$\\ $$\\\\$$$$$$$ |$$ |       \\$$$$  |
   \\__|\\__|      \\_______|$$  ____/  \\______/ \\__|      \\__|  \\__| \\_______|\\__|\\_______|\\__|        \\____/ 
                          $$ |                                                                              
                          $$ |                                                                              
                          \\__|`;

  // ============ TRAP PLAYLIST (50 songs) ============
  const playlistTrap = [
    { title: "Stfu", artist: "42Dugg, Peezy, EWM Kdoe, Bagboy Mel, CASHKIDD, EW", file: "/songs/trap/Stfu.mp3", duration: 195 },
    { title: "Feburary1st", artist: "Lil DoubleO", file: "/songs/trap/Feburary1st.mp3", duration: 104 },
    { title: "Hate It Or Love It", artist: "The Game, 50 Cent", file: "/songs/trap/HateItOrLoveIt.mp3", duration: 206 },
    { title: "MVP", artist: "BashfortheWorld", file: "/songs/trap/MVP.mp3", duration: 103 },
    { title: "All The Way Turnt Up", artist: "Roscoe Dash, Soulja Boy", file: "/songs/trap/AllTheWayTurntUp.mp3", duration: 294 },
    { title: "Walk It Out", artist: "Unk", file: "/songs/trap/WalkItOut.mp3", duration: 173 },
    { title: "Dedication", artist: "Chief Keef", file: "/songs/trap/Dedication.mp3", duration: 170 },
    { title: "Drop My Mask", artist: "Action Pack", file: "/songs/trap/DropMyMask.mp3", duration: 120 },
    { title: "Stuntin' Like My Daddy", artist: "Birdman, Lil Wayne", file: "/songs/trap/StuntinLikeMyDaddy.mp3", duration: 267 },
    { title: "Pressure", artist: "Shoreline Mafia, Fenix Flexin, OHGEESY", file: "/songs/trap/Pressure.mp3", duration: 164 },
    { title: "Fell in Love", artist: "Shoreline Mafia", file: "/songs/trap/FellInLove.mp3", duration: 164 },
    { title: "Bands", artist: "Shoreline Mafia, OHGEESY, Fenix Flexin, Master Kato", file: "/songs/trap/Bands.mp3", duration: 174 },
    { title: "Standing Ovation", artist: "Jeezy", file: "/songs/trap/StandingOvation.mp3", duration: 254 },
    { title: "Get Ya Mind Right", artist: "Jeezy", file: "/songs/trap/GetYaMindRight.mp3", duration: 0 },
    { title: "Shoulda Woulda", artist: "Kodak Black", file: "/songs/trap/ShouldaWoulda.mp3", duration: 0 },
    { title: "Standin' On Bidness", artist: "King Khemoo", file: "/songs/trap/StandinOnBidness.mp3", duration: 0 },
    { title: "Need It", artist: "Migos, YoungBoy Never Broke Again", file: "/songs/trap/NeedIt.mp3", duration: 0 },
    { title: "Whats Happenin'", artist: "Webbie", file: "/songs/trap/WhatsHappenin.mp3", duration: 0 },
    { title: "Walk", artist: "Kodak Black", file: "/songs/trap/Walk.mp3", duration: 0 },
    { title: "3 Peat", artist: "Lil Wayne", file: "/songs/trap/3Peat.mp3", duration: 0 },
    { title: "Type of Way", artist: "Rich Homie Quan", file: "/songs/trap/TypeOfWay.mp3", duration: 0 },
    { title: "XP", artist: "Lelo", file: "/songs/trap/XP.mp3", duration: 0 },
    { title: "Crook for Life", artist: "Mr. Pookie", file: "/songs/trap/CrookForLife.mp3", duration: 0 },
    { title: "Texas", artist: "Mr. Pookie, Mr. Lucci", file: "/songs/trap/Texas.mp3", duration: 0 },
    { title: "Trilla Than a B***h", artist: "Webbie", file: "/songs/trap/TrillaThanABitch.mp3", duration: 0 },
    { title: "Drank in My Cup", artist: "Kirko Bangz", file: "/songs/trap/DrankInMyCup.mp3", duration: 0 },
    { title: "HYFR", artist: "Drake, Lil Wayne", file: "/songs/trap/HYFR.mp3", duration: 0 },
    { title: "Off Dat Drank", artist: "Rob49", file: "/songs/trap/OffDatDrank.mp3", duration: 0 },
    { title: "No Chill", artist: "Moneybagg Yo, Lil Baby", file: "/songs/trap/NoChill.mp3", duration: 0 },
    { title: "I Don't Love Her", artist: "Gucci Mane", file: "/songs/trap/IDontLoveHer.mp3", duration: 0 },
    { title: "Preach", artist: "Young Dolph", file: "/songs/trap/Preach.mp3", duration: 0 },
    { title: "All There", artist: "Jeezy, Bankroll Fresh", file: "/songs/trap/AllThere.mp3", duration: 0 },
    { title: "No Flockin", artist: "Kodak Black", file: "/songs/trap/NoFlockin.mp3", duration: 0 },
    { title: "Shiesty Summer", artist: "Pooh Shiesty", file: "/songs/trap/ShiestySummer.mp3", duration: 0 },
    { title: "Help Me", artist: "Real Boston Richey", file: "/songs/trap/HelpMe.mp3", duration: 0 },
    { title: "Down On Me", artist: "Jeremih, 50 Cent", file: "/songs/trap/DownOnMe.mp3", duration: 0 },
    { title: "Rack City", artist: "Tyga", file: "/songs/trap/RackCity.mp3", duration: 0 },
    { title: "Save Me", artist: "Chief Keef", file: "/songs/trap/SaveMe.mp3", duration: 0 },
    { title: "Dope Love", artist: "Gucci Mane", file: "/songs/trap/DopeLove.mp3", duration: 0 },
    { title: "Life", artist: "Lil Double 0", file: "/songs/trap/Life.mp3", duration: 0 },
    { title: "No Panties", artist: "Young Dolph", file: "/songs/trap/NoPanties.mp3", duration: 0 },
    { title: "Parking Lot", artist: "FreakoKash", file: "/songs/trap/ParkingLot.mp3", duration: 0 },
    { title: "Drug Money", artist: "Yo Gotti, Future", file: "/songs/trap/DrugMoney.mp3", duration: 0 },
    { title: "Half On a Sack", artist: "Three 6 Mafia", file: "/songs/trap/HalfOnASack.mp3", duration: 0 },
    { title: "Stay Fly", artist: "Three 6 Mafia", file: "/songs/trap/StayFly.mp3", duration: 0 },
    { title: "G to the A", artist: "Merkules, Cavetard", file: "/songs/trap/GToTheA.mp3", duration: 0 },
    { title: "30 Boppa", artist: "EST Gee", file: "/songs/trap/30Boppa.mp3", duration: 0 },
    { title: "Members Only", artist: "EST Gee, 42 Dugg", file: "/songs/trap/MembersOnly.mp3", duration: 0 },
    { title: "Young Shiners", artist: "EST Gee", file: "/songs/trap/YoungShiners.mp3", duration: 0 },
    { title: "Opps On Deck", artist: "VonOff1700", file: "/songs/trap/OppsOnDeck.mp3", duration: 0 },
  ];

  // ============ UR & HEART PLAYLISTS (Coming soon) ============
  const playlistUr = [];
  const playlistHeart = [];

  const playlists = [playlistTrap, playlistUr, playlistHeart];
  const playlistNames = ["TRAP", "UR", "HEART"];
  
  const currentPlaylistData = playlists[currentPlaylist];
  const currentTrackData = currentPlaylistData[currentTrack];
  const songTitle = currentTrackData?.title || "—";
  const songArtist = currentTrackData?.artist || "trapurhe radio";
  // Show next 12 songs (scrollable if more)
  const upcoming = currentPlaylistData?.slice(currentTrack + 1, currentTrack + 13) || [];

  // ============ SESSION TIME ============
  const sessionMinutes = Math.floor((Date.now() - sessionStartTime) / 60000);

  // ============ TIME UNTIL NEXT TRACK ============
  const timeUntilNext = duration > 0 ? Math.max(0, duration - currentTime) : 0;
  const minutesUntilNext = Math.floor(timeUntilNext / 60);
  const secondsUntilNext = Math.floor(timeUntilNext % 60);

  // ============ SAVE PREFERENCES ============
  useEffect(() => {
    localStorage.setItem('trapurhe_playlist', currentPlaylist);
  }, [currentPlaylist]);

  useEffect(() => {
    localStorage.setItem('trapurhe_volume', volume);
  }, [volume]);

  // ============ SLEEP TIMER ============
  const setSleepTimer = (minutes) => {
    if (sleepTimerRef.current) clearTimeout(sleepTimerRef.current);
    const endTime = Date.now() + minutes * 60000;
    setSleepTimerEnd(endTime);
    setShowSleepMenu(false);
    
    sleepTimerRef.current = setTimeout(() => {
      if (audioRef.current) {
        audioRef.current.pause();
        setIsPlaying(false);
        if ('mediaSession' in navigator) {
          navigator.mediaSession.playbackState = 'paused';
        }
      }
      setSleepTimerEnd(null);
    }, minutes * 60000);
  };

  const cancelSleepTimer = () => {
    if (sleepTimerRef.current) clearTimeout(sleepTimerRef.current);
    setSleepTimerEnd(null);
  };

  // ============ ADD TO RECENT PLAYS ============
  const addToRecentPlays = (track) => {
    if (!track) return;
    const newRecent = {
      title: track.title,
      artist: track.artist,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };
    setRecentPlays(prev => [newRecent, ...prev].slice(0, 4));
  };

  // ============ TYPEWRITER EFFECT ============
  useEffect(() => {
    const fullText = "LIVE";
    let index = 0;
    
    typewriterIntervalRef.current = setInterval(() => {
      if (index <= fullText.length) {
        setTypewriterText(fullText.slice(0, index));
        index++;
      } else {
        clearInterval(typewriterIntervalRef.current);
      }
    }, 150);
    
    return () => {
      if (typewriterIntervalRef.current) {
        clearInterval(typewriterIntervalRef.current);
      }
    };
  }, []);

  // ============ MEDIA SESSION API (CAR DISPLAY) ============
  useEffect(() => {
    if ('mediaSession' in navigator && currentTrackData) {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: 'trapurhe.art radio',
        artist: songTitle,
        album: songArtist,
        artwork: [{ src: '/images/whystop.jpg', sizes: '512x512', type: 'image/jpeg' }]
      });
      
      navigator.mediaSession.setActionHandler('play', () => {
        if (!isPlaying) togglePlay();
      });
      navigator.mediaSession.setActionHandler('pause', () => {
        if (isPlaying) togglePlay();
      });
      navigator.mediaSession.setActionHandler('previoustrack', () => playPrevious());
      navigator.mediaSession.setActionHandler('nexttrack', () => playNext());
    }
  }, [songTitle, songArtist, currentTrack]);

  // ============ SWITCH PLAYLIST ============
  const switchPlaylist = (index) => {
    if (playlists[index].length === 0) {
      const msg = playlistNames[index] === "UR" ? "UR playlist — coming soon" : "HEART playlist — coming soon";
      alert(msg);
      return;
    }
    
    setCurrentPlaylist(index);
    setCurrentTrack(0);
    setIsPlaying(false);
    setCurrentTime(0);
    setDuration(0);
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      if ('mediaSession' in navigator) {
        navigator.mediaSession.playbackState = 'paused';
      }
    }
    setTimeout(() => {
      setIsPlaying(true);
    }, 100);
  };

  // ============ JUMP TO TRACK ============
  const jumpToTrack = (targetIndex) => {
    if (!currentPlaylistData[targetIndex]) return;
    setCurrentTrack(targetIndex);
    setCurrentTime(0);
    if (!isPlaying) {
      setIsPlaying(true);
    }
  };

  // ============ TRACK PROGRESS ============
  useEffect(() => {
    if (!audioRef.current) return;
    
    const updateProgress = () => {
      if (audioRef.current) {
        setCurrentTime(audioRef.current.currentTime);
        setDuration(audioRef.current.duration || 0);
      }
    };
    
    audioRef.current.addEventListener('timeupdate', updateProgress);
    audioRef.current.addEventListener('loadedmetadata', updateProgress);
    
    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener('timeupdate', updateProgress);
        audioRef.current.removeEventListener('loadedmetadata', updateProgress);
      }
    };
  }, [currentTrack]);

  // ============ CD SPIN ANIMATION ============
  useEffect(() => {
    if (isPlaying) {
      const spin = () => {
        setCdRotation(prev => (prev + 0.8) % 360);
        animationRef.current = requestAnimationFrame(spin);
      };
      animationRef.current = requestAnimationFrame(spin);
    } else {
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
    }
    return () => {
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
    };
  }, [isPlaying]);

  // ============ PLAY NEXT TRACK ============
  const playNext = () => {
    if (!currentPlaylistData.length) return;
    const nextIndex = (currentTrack + 1) % currentPlaylistData.length;
    addToRecentPlays(currentTrackData);
    setCurrentTrack(nextIndex);
    setCurrentTime(0);
  };

  // ============ PLAY PREVIOUS TRACK ============
  const playPrevious = () => {
    if (!currentPlaylistData.length) return;
    const prevIndex = (currentTrack - 1 + currentPlaylistData.length) % currentPlaylistData.length;
    addToRecentPlays(currentTrackData);
    setCurrentTrack(prevIndex);
    setCurrentTime(0);
  };

  // ============ HANDLE SONG END ============
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    
    const handleEnded = () => {
      addToRecentPlays(currentTrackData);
      playNext();
    };
    audio.addEventListener('ended', handleEnded);
    
    return () => audio.removeEventListener('ended', handleEnded);
  }, [currentTrack, currentPlaylist]);

  // ============ PLAY/PAUSE ============
  const togglePlay = async () => {
    if (isPlaying) {
      audioRef.current.pause();
      if ('mediaSession' in navigator) {
        navigator.mediaSession.playbackState = 'paused';
      }
    } else {
      await audioRef.current.play();
      if ('mediaSession' in navigator) {
        navigator.mediaSession.playbackState = 'playing';
      }
    }
    setIsPlaying(!isPlaying);
  };

  // ============ MUTE FUNCTION ============
  const toggleMute = () => {
    if (isMuted) {
      audioRef.current.volume = volume;
      setIsMuted(false);
    } else {
      audioRef.current.volume = 0;
      setIsMuted(true);
    }
  };

  useEffect(() => {
    if (audioRef.current && !isMuted) {
      audioRef.current.volume = volume;
    }
  }, [volume, isMuted]);

  // ============ LOAD TRACK WHEN CHANGED ============
  useEffect(() => {
    if (audioRef.current && currentTrackData) {
      audioRef.current.src = currentTrackData.file;
      audioRef.current.load();
      if (!isMuted) {
        audioRef.current.volume = volume;
      }
      if (isPlaying) {
        audioRef.current.play().catch(e => console.log("Play error:", e));
      }
    }
  }, [currentTrack, currentPlaylist]);

  // ============ LISTENER COUNT ============
  useEffect(() => {
    const interval = setInterval(() => {
      setListenerCount(prev => {
        const change = Math.floor(Math.random() * 5) - 2;
        return Math.max(1, prev + change);
      });
    }, 45000);
    return () => clearInterval(interval);
  }, []);

  // ============ TOGGLE BACKGROUND ============
  const toggleBackground = () => {
    setShowBackground(!showBackground);
  };

  // ============ KEYBOARD CONTROLS ============
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.code === 'Space') {
        e.preventDefault();
        togglePlay();
      } else if (e.code === 'ArrowLeft') {
        e.preventDefault();
        playPrevious();
      } else if (e.code === 'ArrowRight') {
        e.preventDefault();
        playNext();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isPlaying, currentTrack, currentPlaylist]);

  // Format time
  const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Progress percentage
  const progressPercent = duration > 0 ? (currentTime / duration) * 100 : 0;

  // Sleep timer display
  const sleepTimeRemaining = sleepTimerEnd ? Math.max(0, Math.floor((sleepTimerEnd - Date.now()) / 60000)) : null;

  return (
    <div className={`radio-container ${showBackground ? 'with-bg' : ''}`}>
      <audio ref={audioRef} />
      
      <div className="content">
        
        {/* Top bar - Profile + ASCII on left, Playlist on right */}
        <div className="top-bar">
          <div className="top-left">
            <div className="top-profile" onClick={toggleBackground} title="Toggle background">
              <img 
                src="/images/katysosa.jpg" 
                alt="profile"
                className={`profile-img ${isHoveringIcon ? 'hover' : ''}`}
                onMouseEnter={() => setIsHoveringIcon(true)}
                onMouseLeave={() => setIsHoveringIcon(false)}
              />
            </div>
            <pre className="ascii-art">{asciiArt}</pre>
          </div>
          <div className="top-right">
            <div className="playlist-selector">
              {playlistNames.map((name, idx) => (
                <button 
                  key={idx}
                  className={`playlist-chip ${currentPlaylist === idx ? 'active' : ''}`}
                  onClick={() => switchPlaylist(idx)}
                  title={playlists[idx].length === 0 ? `${name} — coming soon` : `Switch to ${name} playlist`}
                >
                  {name}
                  {currentPlaylist === idx && <span className="playing-dot" />}
                </button>
              ))}
            </div>
          </div>
        </div>
        
        {/* Main title (mobile only) */}
        <div className="main-title">
          <h1>TRAPURHE<span className="light">.ART</span></h1>
          <div className="main-radio">RADIO</div>
        </div>
        
        {/* Live Indicator */}
        <div className="live-indicator">
          <span className="live-dot pulse" />
          <span className="live-text">{typewriterText}</span>
          <span className="live-cursor">_</span>
        </div>
        
        {/* Spinning CD with whystop.jpg image */}
        <div className="cd-area" onClick={togglePlay} title={isPlaying ? "Pause" : "Play"}>
          <div 
            className="cd"
            style={{ 
              backgroundImage: `url(/images/whystop.jpg)`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              transform: `rotate(${cdRotation}deg)`
            }}
          >
            <div className="cd-inner" />
            <div className="cd-center" />
          </div>
        </div>
        
        {/* Song Info */}
        <div className="song-info">
          <div className="song-title">{songTitle}</div>
          <div className="song-artist">{songArtist}</div>
        </div>
        
        {/* Progress Bar */}
        <div className="progress-container">
          <div className="progress-bar" style={{ width: `${progressPercent}%` }} />
          <div className="progress-time">
            <span>{formatTime(currentTime)}</span>
            <span>{formatTime(duration)}</span>
          </div>
        </div>
        
        {/* Info Panel + Next Up - Side by Side */}
        <div className="info-nextup-wrapper">
          
          {/* Info Panel */}
          <div className="info-panel">
            <div className="listener-section">
              <div className="listener-count">
                <span className="listener-icon" /> {listenerCount} listening
              </div>
              <div className="timestamp">
                {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </div>
            </div>
            
            <div className="transport">
              <div className="transport-buttons">
                <button className="transport-btn" onClick={playPrevious} title="Previous track (←)">◀◀</button>
                <button className="transport-btn play-btn" onClick={togglePlay} title={isPlaying ? "Pause (space)" : "Play (space)"}>
                  {isPlaying ? "⏸" : "▶"}
                </button>
                <button className="transport-btn" onClick={playNext} title="Next track (→)">▶▶</button>
              </div>
              <div className="right-controls">
                <div className="next-countdown">
                  next in {minutesUntilNext}:{secondsUntilNext.toString().padStart(2, '0')}
                </div>
                <div className="timer-controls">
                  <div className="sleep-timer">
                    <button className="sleep-btn" onClick={() => setShowSleepMenu(!showSleepMenu)} title="Sleep timer">
                      😴
                    </button>
                    {showSleepMenu && (
                      <div className="sleep-menu">
                        <button onClick={() => setSleepTimer(15)}>15 min</button>
                        <button onClick={() => setSleepTimer(30)}>30 min</button>
                        <button onClick={() => setSleepTimer(60)}>60 min</button>
                        {sleepTimerEnd && <button onClick={cancelSleepTimer}>cancel</button>}
                      </div>
                    )}
                  </div>
                  <div className="volume-control">
                    <button className="mute-btn" onClick={toggleMute} title={isMuted ? "Unmute" : "Mute"}>
                      {isMuted ? "🔇" : "🔊"}
                    </button>
                    <input 
                      type="range" 
                      min="0" 
                      max="1" 
                      step="0.01" 
                      value={volume} 
                      onChange={(e) => setVolume(parseFloat(e.target.value))}
                      className="volume-slider"
                    />
                  </div>
                </div>
              </div>
            </div>
            
            <div className="session-info">
              <span>📻 {sessionMinutes} min today</span>
              {sleepTimeRemaining !== null && <span>😴 sleep: {sleepTimeRemaining} min</span>}
            </div>
          </div>
          
          {/* Next Up Panel - Scrollable, shows 12 songs */}
          <div className="nextup-panel">
            <div className="nextup-label">NEXT UP ({upcoming.length})</div>
            <div className="nextup-list">
              {upcoming.map((track, i) => {
                const targetIndex = currentTrack + 1 + i;
                const isNext = i === 0;
                return (
                  <div 
                    key={i} 
                    className={`nextup-item ${isNext ? 'next-up' : ''}`}
                    onClick={() => jumpToTrack(targetIndex)}
                  >
                    <span className="nextup-bullet">{isNext ? "▶" : "▸"}</span>
                    <span className="nextup-text">
                      {track.title} - {track.artist}
                    </span>
                    <span className="nextup-duration">
                      {formatTime(track.duration || 0)}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
          
        </div>
        
        {/* Recent Plays Panel */}
        {recentPlays.length > 0 && (
          <div className="recent-panel">
            <div className="recent-label">RECENTLY PLAYED</div>
            <div className="recent-list">
              {recentPlays.map((play, i) => (
                <div key={i} className="recent-item">
                  <span className="recent-time">{play.time}</span>
                  <span className="recent-text">{play.title} - {play.artist}</span>
                </div>
              ))}
            </div>
          </div>
        )}
        
      </div>
      
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          background: #050508;
          min-height: 100vh;
        }
        
        .radio-container {
          min-height: 100vh;
          background: #0a0a0f;
          transition: background 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }
        
        .radio-container.with-bg {
          background: linear-gradient(135deg, #0a0a0f 0%, #0f0f1a 50%, #0a0a0f 100%);
          position: relative;
        }
        
        .radio-container.with-bg::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: url('/images/bg1.jpg');
          background-size: cover;
          background-position: center;
          opacity: 0.12;
          pointer-events: none;
        }
        
        .content {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 20px;
          position: relative;
          z-index: 2;
          padding-bottom: 30px;
        }
        
        /* Top Bar */
        .top-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
        }
        
        .top-left {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        
        .top-right {
          display: flex;
          align-items: center;
        }
        
        /* ASCII Art */
        .ascii-art {
          display: none;
          font-family: monospace;
          font-size: 4.5px;
          color: rgba(255,255,255,0.04);
          text-align: center;
          line-height: 1.1;
          white-space: pre;
          user-select: none;
          margin: 0;
        }
        
        .playlist-selector {
          display: flex;
          gap: 8px;
          background: rgba(255,255,255,0.03);
          padding: 4px;
          border-radius: 40px;
          border: 1px solid rgba(255,255,255,0.06);
        }
        
        .playlist-chip {
          background: transparent;
          border: none;
          color: rgba(255,255,255,0.4);
          font-size: 0.7rem;
          font-weight: 500;
          letter-spacing: 1px;
          padding: 6px 14px;
          border-radius: 30px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-family: monospace;
        }
        
        .playlist-chip:hover {
          color: rgba(255,255,255,0.7);
          background: rgba(255,255,255,0.05);
        }
        
        .playlist-chip.active {
          background: rgba(124,185,232,0.15);
          color: #7CB9E8;
        }
        
        .playing-dot {
          display: inline-block;
          width: 6px;
          height: 6px;
          background: #ff3355;
          border-radius: 50%;
          margin-left: 6px;
          animation: pulse 1.5s ease infinite;
        }
        
        .profile-img {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          object-fit: cover;
          transition: all 0.2s ease;
          border: 1px solid rgba(255,255,255,0.1);
          cursor: pointer;
        }
        
        .profile-img.hover {
          transform: scale(1.02);
          border-color: rgba(255,255,255,0.25);
        }
        
        /* Main Title */
        .main-title {
          text-align: center;
          margin-top: 10px;
        }
        
        .main-title h1 {
          font-size: 1.4rem;
          font-weight: 500;
          letter-spacing: 3px;
          color: rgba(255,255,255,0.85);
        }
        
        .main-title .light {
          font-weight: 300;
          opacity: 0.5;
        }
        
        .main-radio {
          font-size: 0.65rem;
          letter-spacing: 5px;
          color: rgba(255,255,255,0.3);
          margin-top: 4px;
        }
        
        /* Live Indicator */
        .live-indicator {
          display: flex;
          align-items: center;
          gap: 6px;
          background: rgba(255,255,255,0.03);
          padding: 4px 14px;
          border-radius: 30px;
        }
        
        .live-dot {
          width: 6px;
          height: 6px;
          background: #ff3355;
          border-radius: 50%;
        }
        
        .live-text {
          font-size: 0.7rem;
          letter-spacing: 2px;
          color: rgba(255,255,255,0.8);
          font-weight: 500;
          font-family: monospace;
        }
        
        .live-cursor {
          font-size: 0.7rem;
          color: #ff3355;
          animation: blink 1s step-end infinite;
        }
        
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
        
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }
        
        /* CD Player */
        .cd-area {
          cursor: pointer;
        }
        
        .cd {
          width: 200px;
          height: 200px;
          border-radius: 50%;
          background-size: cover;
          background-position: center;
          box-shadow: 0 20px 35px rgba(0,0,0,0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          transition: box-shadow 0.2s ease;
        }
        
        .cd:hover {
          box-shadow: 0 25px 45px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.05);
        }
        
        .cd-inner {
          width: 140px;
          height: 140px;
          border-radius: 50%;
          background: radial-gradient(circle at 35% 35%, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 60%);
          pointer-events: none;
        }
        
        .cd-center {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #0a0a0f;
          box-shadow: inset 0 0 0 2px rgba(255,255,255,0.15), 0 0 0 2px rgba(0,0,0,0.5);
          pointer-events: none;
        }
        
        /* Song Info */
        .song-info {
          text-align: center;
          width: 100%;
        }
        
        .song-title {
          font-size: 0.9rem;
          font-weight: 500;
          color: rgba(255,255,255,0.85);
        }
        
        .song-artist {
          font-size: 0.65rem;
          color: rgba(255,255,255,0.4);
          margin-top: 2px;
        }
        
        /* Progress Bar */
        .progress-container {
          width: 80%;
          background: rgba(255,255,255,0.06);
          border-radius: 4px;
          padding: 2px;
        }
        
        .progress-bar {
          height: 2px;
          background: #7CB9E8;
          border-radius: 2px;
          transition: width 0.1s linear;
        }
        
        .progress-time {
          display: flex;
          justify-content: space-between;
          margin-top: 4px;
          font-size: 0.5rem;
          color: rgba(255,255,255,0.3);
          font-family: monospace;
        }
        
        /* Info + Next Up Wrapper */
        .info-nextup-wrapper {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        
        /* Info Panel */
        .info-panel {
          width: 100%;
          background: rgba(255,255,255,0.02);
          border: 1px solid rgba(255,255,255,0.04);
          border-radius: 16px;
          padding: 12px;
        }
        
        .listener-section {
          display: flex;
          justify-content: space-between;
          padding-bottom: 8px;
          border-bottom: 1px solid rgba(255,255,255,0.06);
          margin-bottom: 8px;
        }
        
        .listener-count {
          font-size: 0.6rem;
          color: rgba(255,255,255,0.5);
        }
        
        .listener-icon {
          display: inline-block;
          width: 5px;
          height: 5px;
          background: #ff3355;
          border-radius: 50%;
          margin-right: 5px;
        }
        
        .timestamp {
          font-size: 0.6rem;
          color: rgba(255,255,255,0.3);
          font-family: monospace;
        }
        
        .transport {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 10px;
          margin-bottom: 8px;
        }
        
        .transport-buttons {
          display: flex;
          gap: 6px;
        }
        
        .transport-btn {
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.1);
          color: rgba(255,255,255,0.7);
          font-size: 0.7rem;
          padding: 4px 10px;
          border-radius: 30px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-family: monospace;
        }
        
        .transport-btn:hover {
          background: rgba(255,255,255,0.1);
          border-color: rgba(255,255,255,0.2);
        }
        
        .play-btn {
          background: rgba(124,185,232,0.12);
          border-color: rgba(124,185,232,0.25);
        }
        
        .right-controls {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        
        .next-countdown {
          font-size: 0.55rem;
          color: rgba(255,255,255,0.4);
          font-family: monospace;
          background: rgba(255,255,255,0.03);
          padding: 2px 8px;
          border-radius: 20px;
        }
        
        .timer-controls {
          display: flex;
          align-items: center;
          gap: 6px;
        }
        
        .sleep-timer {
          position: relative;
        }
        
        .sleep-btn {
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 20px;
          padding: 3px 8px;
          font-size: 0.65rem;
          cursor: pointer;
          transition: all 0.2s ease;
          color: rgba(255,255,255,0.5);
        }
        
        .sleep-btn:hover {
          background: rgba(255,255,255,0.1);
          color: white;
        }
        
        .sleep-menu {
          position: absolute;
          bottom: 100%;
          right: 0;
          background: #1a1a2e;
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 12px;
          padding: 6px;
          display: flex;
          flex-direction: column;
          gap: 3px;
          z-index: 200;
          margin-bottom: 6px;
        }
        
        .sleep-menu button {
          background: transparent;
          border: none;
          color: rgba(255,255,255,0.7);
          padding: 5px 10px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 0.65rem;
          white-space: nowrap;
        }
        
        .sleep-menu button:hover {
          background: rgba(255,255,255,0.1);
        }
        
        .volume-control {
          display: flex;
          align-items: center;
          gap: 6px;
        }
        
        .mute-btn {
          background: transparent;
          border: none;
          color: rgba(255,255,255,0.5);
          font-size: 0.7rem;
          cursor: pointer;
          transition: color 0.2s ease;
        }
        
        .mute-btn:hover {
          color: rgba(255,255,255,0.8);
        }
        
        .volume-slider {
          width: 60px;
          height: 2px;
          -webkit-appearance: none;
          background: rgba(255,255,255,0.2);
          border-radius: 2px;
          outline: none;
        }
        
        .volume-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(255,255,255,0.7);
          cursor: pointer;
        }
        
        .session-info {
          display: flex;
          justify-content: space-between;
          font-size: 0.5rem;
          color: rgba(255,255,255,0.25);
          padding-top: 8px;
          border-top: 1px solid rgba(255,255,255,0.04);
        }
        
        /* Next Up Panel - SCROLLABLE */
        .nextup-panel {
          width: 100%;
          background: rgba(255,255,255,0.02);
          border: 1px solid rgba(255,255,255,0.04);
          border-radius: 16px;
          padding: 12px;
        }
        
        .nextup-label {
          font-size: 0.55rem;
          text-transform: uppercase;
          letter-spacing: 2px;
          color: rgba(255,255,255,0.3);
          margin-bottom: 8px;
        }
        
        .nextup-list {
          display: flex;
          flex-direction: column;
          gap: 4px;
          max-height: 280px;
          overflow-y: auto;
          padding-right: 4px;
        }
        
        .nextup-list::-webkit-scrollbar {
          width: 4px;
        }
        
        .nextup-list::-webkit-scrollbar-track {
          background: rgba(255,255,255,0.05);
          border-radius: 4px;
        }
        
        .nextup-list::-webkit-scrollbar-thumb {
          background: rgba(124,185,232,0.3);
          border-radius: 4px;
        }
        
        .nextup-item {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 5px 8px;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.2s ease;
          border: 1px solid transparent;
        }
        
        .nextup-item:hover {
          background: rgba(124,185,232,0.08);
          border-color: rgba(124,185,232,0.15);
          transform: translateX(4px);
        }
        
        .nextup-item.next-up {
          background: rgba(124,185,232,0.05);
          border-left: 2px solid #7CB9E8;
        }
        
        .nextup-bullet {
          font-size: 0.6rem;
          color: rgba(255,255,255,0.35);
          transition: all 0.2s ease;
        }
        
        .nextup-item:hover .nextup-bullet {
          color: #7CB9E8;
        }
        
        .nextup-text {
          font-size: 0.65rem;
          color: rgba(255,255,255,0.55);
          flex: 1;
          transition: color 0.2s ease;
        }
        
        .nextup-item:hover .nextup-text {
          color: rgba(255,255,255,0.85);
        }
        
        .nextup-duration {
          font-size: 0.55rem;
          color: rgba(255,255,255,0.25);
          font-family: monospace;
        }
        
        /* Recent Plays Panel */
        .recent-panel {
          width: 100%;
          background: rgba(255,255,255,0.02);
          border: 1px solid rgba(255,255,255,0.04);
          border-radius: 16px;
          padding: 12px;
        }
        
        .recent-label {
          font-size: 0.55rem;
          text-transform: uppercase;
          letter-spacing: 2px;
          color: rgba(255,255,255,0.3);
          margin-bottom: 8px;
        }
        
        .recent-list {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        
        .recent-item {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 0.6rem;
          padding: 3px 0;
        }
        
        .recent-time {
          color: rgba(255,255,255,0.25);
          font-family: monospace;
        }
        
        .recent-text {
          color: rgba(255,255,255,0.45);
        }
        
        /* Desktop Layout */
        @media (min-width: 768px) {
          .content {
            max-width: 900px;
            display: grid;
            grid-template-columns: auto 1fr;
            grid-template-areas:
              "top top"
              "live live"
              "cd cd"
              "song song"
              "progress progress"
              "info-nextup info-nextup"
              "recent recent";
            gap: 16px;
            align-items: start;
          }
          
          .top-bar {
            grid-area: top;
          }
          
          .ascii-art {
            display: block;
            font-size: 5px;
          }
          
          .info-nextup-wrapper {
            grid-area: info-nextup;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;
          }
          
          .live-indicator {
            grid-area: live;
          }
          
          .cd-area {
            grid-area: cd;
          }
          
          .cd {
            width: 220px;
            height: 220px;
          }
          
          .song-info {
            grid-area: song;
          }
          
          .progress-container {
            grid-area: progress;
            width: 60%;
            margin: 0 auto;
          }
          
          .recent-panel {
            grid-area: recent;
          }
          
          .recent-list {
            flex-direction: row;
            justify-content: center;
            gap: 20px;
          }
        }
        
        @media (min-width: 1024px) {
          .content {
            max-width: 1100px;
          }
          
          .cd {
            width: 240px;
            height: 240px;
          }
          
          .ascii-art {
            font-size: 6px;
          }
        }
        
        /* Mobile adjustments */
        @media (max-width: 767px) {
          .top-left .ascii-art {
            display: none;
          }
          
          .recent-list {
            flex-direction: column;
            gap: 6px;
          }
          
          .info-nextup-wrapper {
            gap: 12px;
          }
          
          .progress-container {
            width: 90%;
          }
          
          .right-controls {
            flex-wrap: wrap;
            justify-content: flex-end;
          }
          
          .cd {
            width: 160px;
            height: 160px;
          }
          
          .cd-inner {
            width: 110px;
            height: 110px;
          }
          
          .profile-img {
            width: 40px;
            height: 40px;
          }
          
          .nextup-list {
            max-height: 300px;
          }
        }
      `}</style>
    </div>
  );
}

export default TrapurheRadio;